export const ACCESSIBLE_LEGACY_ATTR_GUID =
  "82028f7a-444a-f111-8ef3-002248aebdfe";
